// Comportamiento comun de las paginas secundarias: nav movil, barra de progreso,
// header compacto, reveals por scroll y smooth scroll con offset de header.
// Requiere el markup .we-header / #we-menu-toggle / .we-scroll-progress__bar.

export default function initPageChrome() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const yearEl = document.getElementById('y');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  const menuToggle = document.getElementById('we-menu-toggle');
  const navLinks = document.querySelector('.we-nav-links');

  if (menuToggle && navLinks) {
    menuToggle.addEventListener('click', () => {
      const isOpen = navLinks.classList.contains('open');
      navLinks.classList.toggle('open', !isOpen);
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      menuToggle.setAttribute('aria-label', isOpen ? 'Abrir menu de navegacion' : 'Cerrar menu de navegacion');
    });

    navLinks.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        navLinks.classList.remove('open');
        menuToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  const progressBar = document.querySelector('.we-scroll-progress__bar');
  const header = document.querySelector('.we-header');

  function updateScrollProgress() {
    if (!progressBar) return;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    progressBar.style.transform = 'scaleX(' + (docHeight > 0 ? window.scrollY / docHeight : 0) + ')';
  }

  function updateHeader() {
    if (header) header.classList.toggle('compact', window.scrollY > 60);
  }

  let scrollTicking = false;
  window.addEventListener('scroll', () => {
    if (!scrollTicking) {
      requestAnimationFrame(() => {
        updateScrollProgress();
        updateHeader();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  const revealElements = document.querySelectorAll('[data-reveal]');

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealElements.forEach(el => revealObserver.observe(el));
  } else {
    revealElements.forEach(el => el.classList.add('revealed'));
  }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const targetId = anchor.getAttribute('href');
      if (targetId === '#') return;

      const targetEl = document.querySelector(targetId);
      if (!targetEl) return;

      e.preventDefault();
      const headerHeight = header ? header.offsetHeight : 0;
      const targetPosition = targetEl.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

      window.scrollTo({ top: targetPosition, behavior: reducedMotion ? 'auto' : 'smooth' });
      history.pushState(null, '', targetId);
    });
  });

  // Muchos navegadores no tienen cliente de correo asociado y el mailto no abre nada.
  // Copiamos la direccion al portapapeles para que el clic siempre tenga un resultado visible.
  document.querySelectorAll('a[href^="mailto:"].btn').forEach(link => {
    link.addEventListener('click', () => {
      if (!navigator.clipboard) return;

      const address = link.getAttribute('href').replace(/^mailto:/, '').split('?')[0];
      const original = link.innerHTML;

      navigator.clipboard.writeText(address).then(() => {
        link.textContent = 'Correo copiado ✓';
        setTimeout(() => { link.innerHTML = original; }, 2000);
      }).catch(() => {});
    });
  });

  updateScrollProgress();
  updateHeader();
}
